var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]})],1),_c('tab-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }